import { useEffect } from 'react';
import { PageContainer, Tile } from 'components/Layout/PageContainer';
import { useInfoDrawer } from 'context/InfoDrawerContext';
import { TopSellingProductsInfoContent } from './TopSellingProductsInfoContent';
import { TopSellingProductsTable } from 'pages/insights-pro/product-tab/reports/top-selling-products/TopSellingProductsTable';

export function TopSellingProducts() {
  const { setContent } = useInfoDrawer();
  useEffect(() => {
    setContent({
      titleKey: 'insights.product.reports.top_selling',
      subtitleKey: 'info.content.all_dates_utc',
      content: <TopSellingProductsInfoContent />,
    });

    return () => {
      setContent(null);
    };
  }, [setContent]);

  return (
    <PageContainer>
      <Tile titleId="insights.product.reports.top_selling" />
      <TopSellingProductsTable />
    </PageContainer>
  );
}
